export class AdditionalElementsToKitSearchRequest {
    public listIdKit: number[] = [];
    public idSector?: number;
}